module.exports = __webpack_public_path__ + "img/avatars-06.d551207e.svg";